import { Action } from 'redux'
import * as Actions from './actionTypes'
import { Customer, CustomerRecordsFilters } from 'src/common/models/customer'
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions'

export interface getCustomersAction extends Action {
    filters?: CustomerRecordsFilters
}
export interface getCustomersSuccessAction extends Action {
    customers: Customer[]
}
export const getCustomersApi = (filters?: CustomerRecordsFilters): getCustomersAction => ({
    type: Actions.GET_CUSTOMERS_API,
    filters,
})
export const getCustomersApiSuccess = (customers: any): getCustomersSuccessAction => ({
    type: Actions.GET_CUSTOMERS_API_SUCCESS,
    customers,
})
export const getCustomersApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_CUSTOMERS_API_ERROR,
    error,
)


export interface UpsertCustomerAction extends Action {
    customer: Customer
}
export interface UpsertCustomerSuccessAction extends Action {
    customer: Customer
}
export const upsertCustomerApi = (customer: Customer): UpsertCustomerAction => ({
    type: Actions.UPSERT_CUSTOMER_API,
    customer,
})
export const upsertCustomerApiSuccess = (customer: Customer): UpsertCustomerSuccessAction => ({
    type: Actions.UPSERT_CUSTOMER_API_SUCCESS,
    customer,
})
export const upsertCustomerError = (error?): ErrorAction => ({
    type: Actions.UPSERT_CUSTOMER_API_ERROR,
    error,
})

export interface GetCustomerByIdAction extends Action {
    id: number
}
export interface GetCustomerByIdSuccessAction extends Action {
    customer: Customer
}
export const getCustomerByIdApi = (id: number): GetCustomerByIdAction => ({
    type: Actions.GET_CUSTOMER_BY_ID_API,
    id,
})
export const getCustomerByIdApiSuccess = (customer: Customer): GetCustomerByIdSuccessAction => ({
    type: Actions.GET_CUSTOMER_BY_ID_API_SUCCESS,
    customer,
})
export const getCustomerByIdError = (error?): ErrorAction => ({
    type: Actions.GET_CUSTOMER_BY_ID_API_ERROR,
    error,
})

export const cleanCurrentCustomer = (): Action => ({
    type: Actions.CLEAN_CURRENT_CUSTOMER,
})

export interface SendAccountBalancePayload {
    customerId: number
    serviceContractDebitIds?: number[]
    isPartialAccountBalance?: boolean
}
export interface SendAccountBalanceAction extends Action {
    payload: SendAccountBalancePayload
}
export interface SendAccountBalanceSuccessAction extends Action {
    success: boolean
}
export const sendAccountBalanceApi = (payload: number | SendAccountBalancePayload): SendAccountBalanceAction => ({
    type: Actions.SEND_ACCOUNT_BALANCE_API,
    payload: typeof payload === "number"
        ? { customerId: payload }
        : payload,
})
export const sendAccountBalanceApiSuccess = (success: boolean): SendAccountBalanceSuccessAction => ({
    type: Actions.SEND_ACCOUNT_BALANCE_API_SUCCESS,
    success,
})
export const sendAccountBalanceError = (error?): ErrorAction => ({
    type: Actions.SEND_ACCOUNT_BALANCE_API_ERROR,
    error,
})
